import '../../scss/components/_slider-with-images.scss';

export class SliderWithImages {
    constructor (target) {
      this.section = target;
    }

    async init () {
      if (!this.section || CMS.editMode) {
        return;
      }

      const { default: Swiper } = await import('swiper');
      const { Navigation, Pagination } = await import('swiper/modules');

      await import('swiper/css');
      await import('swiper/css/navigation');
      await import('swiper/css/pagination');

      const config = {
        navigation: {
          nextEl: this.section.querySelector('.swiper-button-next'),
          prevEl: this.section.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: this.section.querySelector('.swiper-pagination'),
          type: 'fraction',
        },
        modules: [Navigation, Pagination],
      };

      const sliderElement = this.section.querySelector('.swiper')

      new Swiper(sliderElement, config);

      this.loading(false);
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
